// Which child a parent is learning as. Empty = the account itself. The choice is kept on this device; the lesson requests
// (see lib/api.js) carry it as ?learner_id=<child id>, and the server runs them as that child.
const KEY = "hv_stories_learner";
const NAME_KEY = "hv_stories_learner_name";

export const getActiveLearner = () => {
  try { return localStorage.getItem(KEY) || ""; } catch { return ""; }
};

export const getActiveLearnerName = () => {
  try { return localStorage.getItem(NAME_KEY) || ""; } catch { return ""; }
};

export const setActiveLearner = (id, name = "") => {
  try {
    if (id) { localStorage.setItem(KEY, id); localStorage.setItem(NAME_KEY, name || ""); } else { localStorage.removeItem(KEY); localStorage.removeItem(NAME_KEY); }
  } catch { /* private window: the choice just lasts until reload */ }
};

// Only the requests that belong to the learner's own journey are sent as the child. Sign-in, the child list itself, plan and
// community requests always belong to the signed-in parent.
const LEARNER_PATHS = ["/today", "/stories", "/progress", "/weekly-recap", "/me/stories-per-week", "/chat"];
export const isLearnerPath = (url = "") => {
  const path = String(url).split("?")[0].replace(/^\/api/, "");
  return LEARNER_PATHS.some((p) => path === p || path.startsWith(p + "/"));
};

// Child profiles are created only in the HikmahVerses dashboard (same origin as the common login page).
const LOGIN_URL = process.env.REACT_APP_LOGIN_URL || "http://localhost:3007/login";
export const profilesPageUrl = () => {
  try { return `${new URL(LOGIN_URL).origin}/dashboard?page=profiles`; } catch { return "/"; }
};
